import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { environment } from 'environments/environment';
import { withReturnUrl } from 'app/utilities/url.utilities';
import { SharedDataService } from 'app/services/sharedData.service';
import { UserService } from 'app/users/user.service';
import { UserProfileRecord } from 'app/users/user-profile-record';
import { PageConfig } from 'config/page.config';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']

})
export class HeaderComponent implements OnInit{
  @ViewChild('mainNav') mainNav!: ElementRef;
  @ViewChild('userNav') userNav!: ElementRef;
  mainNavVisible = false;
  userNavVisible = false;
  mainNavActive = false;
  userNavActive = false;
  cartQuantity: number = 0;
  displayQuantity: boolean = false;
  sharedDataQuantitySub!: Subscription;
  userLoginSub!: Subscription;
  isUserLoggedIn: boolean = false;
  appInfo!: any;

  constructor(
    private router: Router,
    private userService: UserService,
    private sharedDataService: SharedDataService
  ) {
  }
  ngOnInit(): void {
    this.checkIfUserLoggedIn();
    if(this.user && this.user.customerNumber) {
      this.retrieveCartQuantity();
    } else {
      this.displayQuantity = false; 
    }
  }

  checkIfUserLoggedIn() {
    let userInfo = this.sharedDataService.userInfo;
    if(!this.user && userInfo){
      //console.log('setting user profile to '+ JSON.stringify(userInfo))
      this.userService.setProfile(userInfo);
    }
  }

  retrieveCartQuantity() {
    let quantity = sessionStorage.getItem('quantity');
    this.sharedDataQuantitySub = this.sharedDataService.getQuantity.subscribe( data=>{
      if(data) {
        this.cartQuantity = data;
        if(data > 0)
          this.displayQuantity = true;
        else
          this.displayQuantity = false; 
      }
    }); 
    if(Number(quantity) > 0) {
      this.cartQuantity = Number(quantity);
      this.displayQuantity = true;
    } else
      this.displayQuantity = false;
  }

  get amaWireUrl(): string {
    return environment.amaWire;
  }

  get amaStoreUrl(): string {
    return environment.amaStore;
  }

  get jamaUrl(): string {
    return environment.jama;
  }

  get amaHomeUrl(): string {
    return environment.amaHome;
  }

  get storeHome(): string {
    return environment.storeHome;
  }

  get freidaUrl(): string {
    return environment.freida;
  }

  get edHubUrl(): string {
    return environment.edHub;
  }

  get insuranceUrl(): string {
    return environment.insurance;
  }

  get cptUrl(): string {
    return environment.cpt;
  }
  
  get journalOfEthicsUrl(): string {
    return environment.journalofethics;
  }

  get accountManagementCenterUrl(): string {
    return environment.amaAccount;
  }

  get becomeMemberUrl(): string {
    return environment.becomeMember;
  }

  get onlineCodingUrl(): string {
    return environment.onlineCoding;
  }

  get memBenefitsUrl(): string {
    return environment.memBenefits;
  }

  get joinRenewUrl(): string {
    return environment.joinRenew;
  }

  get logoutUrl(): string {
    return withReturnUrl(environment.logout, environment.ocm);
  }

  get createAccountUrl(): string {
    return withReturnUrl(environment.createAccount, environment.ocm);
  }
  get user(): UserProfileRecord {
    return this.userService.profile;
  }

  get isUserMember(): boolean {
    return this.user && this.user?.groups ? this.userService.isInGroup('member') : false;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (this.mainNav.nativeElement.contains(event.target)) {
      this.toggleMainNav();
    } else if (this.userNav.nativeElement.contains(event.target)) {
      this.toggleUserNav();
    } else {
      this.toggleNavOff();
    }
  }

  private toggleMainNav(): void {
    this.mainNavActive = !this.mainNavActive;
    this.mainNavVisible = !this.mainNavVisible;
    this.userNavActive = false;
    this.userNavVisible = false;
  }

  private toggleUserNav() {
    this.userNavActive = !this.userNavActive;
    this.userNavVisible = !this.userNavVisible;
    this.mainNavActive = false;
    this.mainNavVisible = false;
  }

  private toggleNavOff() {
    this.mainNavActive = false;
    this.userNavActive = false;
    this.mainNavVisible = false;
    this.userNavVisible = false;
  }

  ngOnDestroy() {
    // prevent memory leak when component destroyed
    if(this.sharedDataQuantitySub)
      this.sharedDataQuantitySub.unsubscribe();
  }

  logoutUser() {
    sessionStorage.clear();
    window.location.assign(this.logoutUrl);
  }

  displayCart() {
    this.router.navigate([PageConfig.paths.ocm.billing]);
  }
}
